import { gql } from '@generated/gql';

const selectEnergyQuotes = gql(`
  mutation SelectEnergyQuotes($input: SelectEnergyQuotesInput!) {
    selectEnergyQuotes(input: $input) {
      ...BundleBasket
    }
  }
`);

const deselectEnergyQuotes = gql(`
  mutation DeselectEnergyQuotes($basketId: ID!) {
    deselectEnergyQuotes(basketId: $basketId) {
      ...BundleBasket
    }
  }
`);

const updateEnergyRequirements = gql(`
  mutation SetEnergyDetails($details: EnergyQuoteRequirementsInput!) {
    updateEnergyQuoteRequirements(details: $details) {
       ...BundleBasket
    }
  }
`);

export { updateEnergyRequirements, selectEnergyQuotes, deselectEnergyQuotes };
